import { useQuery } from '@apollo/client';

import BrowseQuerySkillsByNameDocumentNode from 'bundles/browse-common/queries/BrowseQuerySkillsByName.graphql';
import type {
  BrowseQuerySkillsByNameQuery,
  BrowseQuerySkillsByNameQueryVariables,
} from 'bundles/browse-common/queries/__generated__/BrowseQuerySkillsByName';
import { type Skill } from 'bundles/browse-common/types/Skill';

type Result<T> = {
  data?: T;
  loading: boolean;
};

export function useBrowseQuerySkillsByName(skillName: string, skip = false): Result<Skill> {
  const { data, loading } = useQuery<BrowseQuerySkillsByNameQuery, BrowseQuerySkillsByNameQueryVariables>(
    BrowseQuerySkillsByNameDocumentNode,
    {
      skip,
      variables: {
        skillName,
      },
      context: {
        clientName: 'gatewayGql',
      },
      errorPolicy: 'all',
    }
  );

  const skill = data?.Skills?.querySkills?.elements?.find(
    (element) => element.skillName.toLowerCase() === skillName.toLowerCase()
  );

  return {
    data: skill,
    loading,
  };
}
